<script>
export default {
  name: "ReportTerminalsServicesHyperLink",
  functional: true,
  props: {
    row: Object,
    column: String,
    OpenServiciosDetail: Function
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    //let clase = String;
    /*
    switch (col) {
      case "CantTotalTerminales":
        clase = "blue bold";
        break;

      case "CantTeminalesActivas":
        clase = "green bold";
        break;

      case "CantTeminalesInactivas":
        clase = "red bold";
        break;
    }
    */
    // console.log("CONTEXT: ",)
    // context.props.OpenServiciosDetail();
    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#"
          //class: clase
        },
        on: {
          click: () => {
            if (context.props.OpenServiciosDetail !== undefined) {
              context.props.OpenServiciosDetail(
                context.props.row,
                context.props.column
              );
            } else {
              //const {OpenServiciosDetail} = context.props;
              //OpenServiciosDetail(context.props.row, context.props.column)
            }
            //.log(context.props)
          }
        }
      },

      val > 0 ? val : ""
    );
  }
};
</script>
